import {IBottomNavigationBarService} from "./bottom-navigation-bar.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {BottomNavigationBarMenuItemConfigReader} from "./bottom-navigation-bar-menu-item-config-reader";
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";
import {IMenuItemRenderer} from "../menu-items-common/renderer/menu-item.renderer.interface";
import {
    GenericBottomNavigationBarMenuItemRenderer
} from "./menu-items/generic-bottom-navigation-bar-menu-item.renderer";
import {makeObservable, observable, runInAction} from "mobx";

export class BottomNavigationBarService extends ServiceBase implements IBottomNavigationBarService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._menuItemConfigReader = new BottomNavigationBarMenuItemConfigReader(services);

        /*
        //Uncomment this when we will have custom renderers for bottom navigation bar menu items
        let rendererModules = require.context('./menu-items/custom-renderers', true, /.+\.renderer\.(ts|tsx)$/);
        this._customMenuItems = loadCustomMenuItemsRenderers(rendererModules.keys().map(rendererModules), this._menuItemConfigReader, this.services);
         */

        makeObservable(this);

        this.reaction(() => this.services.routing.currentRoute, () => {
            this.activeMenuItemKey = null;
        });

        this.services.sdk.events.onSecondWebViewClose(() => {
            this.activeMenuItemKey = null;
        });
    }

    @observable.ref
    private _activeMenuItemKey: MenuItemKey | null = null;

    get activeMenuItemKey(): MenuItemKey | null {
        return this._activeMenuItemKey;
    }

    set activeMenuItemKey(value: MenuItemKey | null) {
        runInAction(() => {
           this._activeMenuItemKey = value;
        });
    }

    private readonly _menuItemConfigReader: BottomNavigationBarMenuItemConfigReader;
    private readonly _customMenuItems: Partial<Record<MenuItemKey, IMenuItemRenderer>> = {};

    private _getMenuItem(key: MenuItemKey): IMenuItemRenderer {
        let customMenuItem = this.services.regulation.current.menuItems.getBottomNavBarMenuItem(key);
        if(customMenuItem) {
            return customMenuItem;
        }

        customMenuItem = this._customMenuItems[key]
        if(customMenuItem) {
            return customMenuItem;
        }

        return new GenericBottomNavigationBarMenuItemRenderer(key, this._menuItemConfigReader, this.services);
    }

    getMenuItems(): IMenuItemRenderer[] {
        return (this.services.configuration.data.bottomNavigationBar.menuItemsOrder || [])
            .map(key => this._getMenuItem(key))
            .filter(menuItem => menuItem.display);
    }

}